import { render, staticRenderFns } from "./TemplateItemEdit.vue?vue&type=template&id=4e3267b7&scoped=true"
import script from "./TemplateItemEdit.vue?vue&type=script&lang=js"
export * from "./TemplateItemEdit.vue?vue&type=script&lang=js"
import style0 from "./TemplateItemEdit.vue?vue&type=style&index=0&id=4e3267b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3267b7",
  null
  
)

export default component.exports